import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Ordem de Produção", -1)
const _hoisted_3 = { style: {"display":"flex","align-items":"center","gap":"6px"} }
const _hoisted_4 = { class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir OP", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Mapa de Produção", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Etiqueta de Amostra", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Etiqueta de Identificação de Produção", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Etiqueta de Garantia", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Etiqueta Caixa - Envase", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Concluir Produção", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Iniciar Produção", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Atualizar Controles", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Atualizar Obsercações", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar Ordem de Produção", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_engenharia_producao = _resolveComponent("selecionar-engenharia-producao")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ordem_producao_etapas = _resolveComponent("ordem-producao-etapas")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_consulta_produtos_modal = _resolveComponent("consulta-produtos-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "70%",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-pcp scroll-modal",
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_tag, {
              title: _ctx.state.nomeStatus,
              class: _normalizeClass('ss-tag-status titulo-'+ _ctx.state.corStatus)
            }, null, 8, ["title", "class"]),
            _createTextVNode(_toDisplayString(_ctx.state.nomeStatus), 1)
          ])
        ])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_dropdown, null, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimirOrdemProducao && _ctx.imprimirOrdemProducao(...args)))
                    }, _hoisted_6)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imprimirMapaProducao && _ctx.imprimirMapaProducao(...args)))
                    }, _hoisted_8)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimirEtiqueta(6)))
                    }, _hoisted_10)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimirEtiqueta(2)))
                    }, _hoisted_12)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imprimirEtiqueta(3)))
                    }, _hoisted_14)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.imprimirEtiqueta(7)))
                    }, _hoisted_16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_4, [
                  _createVNode(_component_icone, { nome: "imprimir" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.state.produtoAcabadoEditavel)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.salvar()))
            }, _hoisted_18))
          : _createCommentVNode("", true),
        (_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Produzindo)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validarConclusao()))
            }, _hoisted_20))
          : _createCommentVNode("", true),
        (_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Pendente)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.IniciarOrdemProducao()))
            }, _hoisted_22))
          : _createCommentVNode("", true),
        (_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido && _ctx.state.atualizarControles === true)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.AtualizarControlesOPConcluida()))
            }, _hoisted_24))
          : _createCommentVNode("", true),
        (_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido && _ctx.state.atualizarObservacao === true)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.AtualizarObsercacaoDeOPConcluida()))
            }, _hoisted_26))
          : _createCommentVNode("", true),
        (_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Produzindo || _ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido)
          ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 5 }, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.validarReversaoStatusOP && _ctx.validarReversaoStatusOP(...args)))
                        }, [
                          _createElementVNode("span", null, "Voltar Status para " + _toDisplayString(_ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido ? 'Produzindo' : 'Pendente'), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validarCancelamentoOP && _ctx.validarCancelamentoOP(...args)))
                        }, _hoisted_29)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, { placement: "top" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_27, [
                      _createVNode(_component_icone, { nome: "mais-acoes" })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo Produção",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_producao, {
                          varios: false,
                          "codigo-selecionado": _ctx.state.tipoProducao.codigo,
                          "onUpdate:codigoSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.tipoProducao.codigo) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          disabled: !(_ctx.state.editavel)
                        }, null, 8, ["codigo-selecionado", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_a_form_item, {
                      label: "Data Criação",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ordemProducao.dataCriacao,
                          "onUpdate:dataSelecionada": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.ordemProducao.dataCriacao) = $event)),
                          disabled: _ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido
                        }, null, 8, ["dataSelecionada", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_a_form_item, {
                      label: "Engenharia Produção",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_engenharia_producao, {
                          varios: false,
                          "codigo-selecionado": _ctx.state.ordemProducao.codigoEngenharia,
                          "onUpdate:codigoSelecionado": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.ordemProducao.codigoEngenharia) = $event)),
                          tipoProducao: _ctx.state.tipoProducao.codigo,
                          descricaoSelecionado: _ctx.state.ordemProducao.nome,
                          "onUpdate:descricaoSelecionado": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.ordemProducao.nome) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.PreencherEngenhariaProduto())),
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["codigo-selecionado", "tipoProducao", "descricaoSelecionado", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_a_form_item, {
                      label: "UN",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_unidade_produto_movimento, {
                          codigoProdutoDefinicao: _ctx.state.ordemProducao.codigoProduto,
                          "onUpdate:codigoProdutoDefinicao": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.ordemProducao.codigoProduto) = $event)),
                          codigoUnidadeSelecionada: _ctx.state.ordemProducao.codigoUnidade,
                          "onUpdate:codigoUnidadeSelecionada": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.ordemProducao.codigoUnidade) = $event)),
                          sigla: _ctx.state.unidade.sigla,
                          "onUpdate:sigla": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.unidade.sigla) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          apresentarApenasSigla: true,
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "sigla", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_a_form_item, {
                      label: "Quantidade a Produzir",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: _ctx.state.ordemProducao.quantidadeProduzir,
                          "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.ordemProducao.quantidadeProduzir) = $event)),
                          onFocus: _ctx.onFocusQuantidadeProduzir,
                          onBlur: _ctx.onBlurQuantidadeProduzir,
                          disabled: !_ctx.state.editavel || _ctx.state.ordemProducao.transferirLote === true,
                          quantidadeCasasDecimais: _ctx.state.unidade.casasDecimais
                        }, null, 8, ["valor", "onFocus", "onBlur", "disabled", "quantidadeCasasDecimais"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_a_form_item, {
                      label: "Número Interno",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.ordemProducao.numeroInterno) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, _hoisted_39), [
                          [_vModelText, _ctx.state.ordemProducao.numeroInterno]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_a_form_item, {
                      label: "Número do Lote",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.ordemProducao.numeroLote) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, _hoisted_41), [
                          [_vModelText, _ctx.state.ordemProducao.numeroLote]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_a_form_item, {
                      label: "Data Validade Lote",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ordemProducao.dataValidadeLote,
                          "onUpdate:dataSelecionada": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.ordemProducao.dataValidadeLote) = $event)),
                          disabled: _ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido
                        }, null, 8, ["dataSelecionada", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_a_form_item, {
                      label: "Data de Início",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ordemProducao.dataInicio,
                          "onUpdate:dataSelecionada": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.ordemProducao.dataInicio) = $event)),
                          disabled: _ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido
                        }, null, 8, ["dataSelecionada", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_a_form_item, {
                      label: "Data de Conclusão",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ordemProducao.dataConclusao,
                          "onUpdate:dataSelecionada": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.ordemProducao.dataConclusao) = $event)),
                          disabled: _ctx.state.ordemProducao.status === _ctx.EStatusProducao.Concluido,
                          onBlur: _ctx.confirmarAtualizacaoValidadeLote
                        }, null, 8, ["dataSelecionada", "disabled", "onBlur"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.ordemProducao.transferirLote,
                          "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.ordemProducao.transferirLote) = $event)),
                          disabled: !_ctx.state.editavel
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Transferir lote")
                          ]),
                          _: 1
                        }, 8, ["checked", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ordem_producao_etapas, {
              etapas: _ctx.state.ordemProducao.etapasProducao,
              "onUpdate:etapas": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.ordemProducao.etapasProducao) = $event)),
              tipo: 0,
              empresas: _ctx.telaBase.empresasSelecionadas,
              codigoOrdemProducao: _ctx.state.ordemProducao.codigo,
              controles: _ctx.state.ordemProducao.controlesProducao,
              "onUpdate:controles": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.ordemProducao.controlesProducao) = $event)),
              cips: _ctx.state.ordemProducao.cips,
              "onUpdate:cips": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.ordemProducao.cips) = $event)),
              editavel: _ctx.state.editavel,
              produtoAcabadoEditavel: _ctx.state.produtoAcabadoEditavel,
              criarApontamentoProdutoAcabado: _ctx.state.criarApontamentoProdutoAcabado,
              "onUpdate:criarApontamentoProdutoAcabado": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.criarApontamentoProdutoAcabado) = $event)),
              criarApontamentoMateriaPrima: _ctx.state.editarApontamentoMateriaPrima,
              "onUpdate:criarApontamentoMateriaPrima": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.editarApontamentoMateriaPrima) = $event)),
              "editar-apontamento-materia-prima": _ctx.state.editarApontamentoMateriaPrima,
              "status-ordem-producao": _ctx.state.ordemProducao.status,
              "aba-etapa-ativa": _ctx.state.abaAtiva,
              "onUpdate:abaEtapaAtiva": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.abaAtiva) = $event)),
              "casas-decimais-custo": _ctx.state.ordemProducao.casasDecimaisCusto,
              "codigo-produto-ordem-producao": _ctx.state.ordemProducao.codigoProduto,
              "atualizar-controles": _ctx.state.atualizarControles,
              "onUpdate:atualizarControles": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.atualizarControles) = $event))
            }, null, 8, ["etapas", "empresas", "codigoOrdemProducao", "controles", "cips", "editavel", "produtoAcabadoEditavel", "criarApontamentoProdutoAcabado", "criarApontamentoMateriaPrima", "editar-apontamento-materia-prima", "status-ordem-producao", "aba-etapa-ativa", "casas-decimais-custo", "codigo-produto-ordem-producao", "atualizar-controles"]),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_a_form_item, {
                      label: "Observação",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("textarea", {
                          type: "textarea",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.ordemProducao.observacao) = $event)),
                          rows: "2",
                          onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.estrategiaAlteracaoObservacao()))
                        }, null, 544), [
                          [_vModelText, _ctx.state.ordemProducao.observacao]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"]),
        _createVNode(_component_consulta_produtos_modal, {
          visivel: _ctx.state.exibirRastreabilidade,
          "onUpdate:visivel": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.exibirRastreabilidade) = $event)),
          empresa: _ctx.props.operacao.empresaSelecionada,
          preSelecao: _ctx.state.produtosSelecionados,
          "tipo-selecao": _ctx.state.tipoSelecaoRastreabilidade,
          onConfirmacao: _ctx.lancarSelecaoEstoqueRastreabilidade
        }, null, 8, ["visivel", "empresa", "preSelecao", "tipo-selecao", "onConfirmacao"]),
        _createVNode(_component_preview_pdf, {
          arquivos: _ctx.state.arquivosPdf
        }, null, 8, ["arquivos"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}